import React, { useState } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import HomeScreen from "./components/HomeScreen/HomeScreen";
import NavBar from "./components/NavBar/NavBar";
import About from "./components/About/About";
import "./main.css";
import Prices from "./components/Prices/Prices";
import Schedule from "./components/Schedule/Schedule";
import Contacts from "./components/Contacts/Contacts";
import Footer from "./components/Footer/Footer";
import InactivityModalHandler from "./components/InactivityModal/InactivityModalHandler";
import Blog from "./components/Blog/Blog";

function App() {
  const [ , setIsActive] = useState(true);

  return (
    <div className="App">
      <Router>
        <InactivityModalHandler
          onActive={() => {
            setIsActive(true);
          }}
          onIdle={() => {
            setIsActive(false);
          }}
        />
        <NavBar />
        <Routes>
          <Route path="/" element={<HomeScreen />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/prices" element={<Prices />}></Route>
          <Route path="/schedule" element={<Schedule />}></Route>
          <Route path="/contacts" element={<Contacts />}></Route>
          <Route path="/blog" element={<Blog />}></Route>
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
